/**
 * Headless impersonation **start** route (Expo: `app/app/impersonate.tsx`).
 * No UI — `?email=` / `?userId=` start flow then replace to `/app`. End uses `UNIMPERSONATE_PATH`.
 */

export const IMPERSONATION_HANDLER_PATH = '/app/impersonate' as const

/** Old bookmark URL — `app/app/admin-impersonate.tsx` redirects here with the same query string. */
export const LEGACY_IMPERSONATION_START_PATH = '/app/admin-impersonate' as const

/** @deprecated Use IMPERSONATION_HANDLER_PATH */
export const ADMIN_IMPERSONATE_DEBUG_ROUTE = IMPERSONATION_HANDLER_PATH

/** Axios timeout for POST impersonate/end so exit cannot hang indefinitely (unimpersonate route). */
export const IMPERSONATION_END_API_TIMEOUT_MS = 12_000 as const

/** Max time on `/app/unimpersonate` before clearing session + navigating home (safety net). */
export const UNIMPERSONATE_NAV_FAILSAFE_MS = 15_000 as const

export const UNIMPERSONATE_PATH = '/app/unimpersonate' as const

/** Marketing-site exit route (outside `/app/*`). */
export const WEBSITE_UNIMPERSONATE_PATH = '/unimpersonate' as const

export const IMPERSONATION_QUERY = {
  EMAIL: 'email',
  USER_ID: 'userId',
} as const

export function buildImpersonationEndUrl(): string {
  return UNIMPERSONATE_PATH
}

export function buildImpersonationStartUrlFromEmail(email: string): string {
  const q = `${IMPERSONATION_QUERY.EMAIL}=${encodeURIComponent(email.trim())}`
  return `${IMPERSONATION_HANDLER_PATH}?${q}`
}

export function buildImpersonationStartUrlFromUserId(userId: string): string {
  const q = `${IMPERSONATION_QUERY.USER_ID}=${encodeURIComponent(userId.trim())}`
  return `${IMPERSONATION_HANDLER_PATH}?${q}`
}
